module.exports = __webpack_public_path__ + "img/trash.a06ffe05.png";